import * as React from 'react';
import styled from "styled-components";
import TwoColumnTable, {TwoColumnTableItem, TwoColumnTableProps} from "components/TwoColumnTable";
import DoughnutChart, {DoughnutChartItem} from "components/DoughnutChart";
import {getNumberFromPercentValue} from "../../helpers";
import Filter from "../Filter";

export interface StatisticSessionTimeProps {
  data: TwoColumnTableProps;
  colors: string[];
}

const Container = styled.div`
  display: grid;
  gap: 20px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 
    minmax(375px, 380px)
    minmax(375px, 490px);
  gap: 18px;
`;

const ChartBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 
    1px
    solid
    ${({theme}) => theme.variables.borderColor};
`;

export default function StatisticSessionTime(props: StatisticSessionTimeProps) {
  const [period, setPeriod] = React.useState<string | number>('day')

  /**
   * the function return data array for doughnut chart
   */
  function getDoughnutChartData(): DoughnutChartItem[] {
    /**
     * the function return data item for doughnut chart
     */
    function getDataFromItem(item: TwoColumnTableItem): DoughnutChartItem {
      return {
        label: item.label,
        value: getNumberFromPercentValue(item.value)
      }
    }

    return props
      .data
      .items
      .map(getDataFromItem)
  }

  return (
    <Container>
      <Filter
        defaultValue={period}
        onChange={(value) => setPeriod(value)}
        items={[
          {
            label: 'В день',
            value: 'day',
          },
          {
            label: 'Последний месяц',
            value: 'lastMonth',
          },
          {
            label: '3 месяца',
            value: 'threeMonth',
          },
          {
            label: '6 месяцев',
            value: 'sixMonth',
          },
          {
            label: 'Год',
            value: 'year',
          },
        ]}
      />
      <Row>
        <ChartBox>
          <DoughnutChart
            data={getDoughnutChartData()}
            title='12ч 56м'
            description="Среднее время за сессию"
            colors={props.colors}
          />
        </ChartBox>
        <TwoColumnTable {...props.data} />
      </Row>
    </Container>
  )
}